(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@microapps/double-invite-retail"] = factory();
	else
		root["@microapps/double-invite-retail"] = factory();
})(window, function() {
return 